import { OFF_NETWORK } from '@locales/id/labels';
import { Chip } from '@ui';

/** "Di luar jaringan": the shipment left the origin's line in the distribution network (amber: worth a look). */
export function OffNetworkChip({ show }: { show?: boolean }) {
  return show ? (
    <Chip tone="amber" title={OFF_NETWORK.tip}>
      {OFF_NETWORK.chip}
    </Chip>
  ) : null;
}
